import React from "react";
import Spinner from "../../../Components/common/Spinner/Spinner";
import "./styles.scss";

const CloudBackdrop = ({
  show,
  absolute = false,
  message = "",
  spinner = true,
  messageStyle = {},
  color,
}) =>
  show ? (
    <div
      className={`Backdrop-cl ${absolute ? "Backdrop-cl--absolute" : ""}`}
      style={{ backgroundColor: color ? color : null }}>
      {spinner && <Spinner />}
      {message && (
        <div className="Backdrop-cl__message" style={messageStyle}>
          {message}
        </div>
      )}
    </div>
  ) : null;

export default CloudBackdrop;
